class BundleQuickAdd extends HTMLElement {
  constructor() {
    super();
    this.variantId = this.getAttribute('data-variant-id');
    this.button = this.querySelector('button');
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    if (!this.variantId) {
      console.error('BundleQuickAdd: No variant ID provided');
      return;
    }

    // Add loading spinner HTML structure to match Dawn's approach
    this.setupLoadingSpinner();
    
    // Bind event handlers
    this.button.addEventListener('click', this.onAddToCartClick.bind(this));
    
    if (document.querySelector('cart-drawer')) {
      this.button.setAttribute('aria-haspopup', 'dialog');
    }
  }

  setupLoadingSpinner() {
    // Create loading spinner to match Dawn's structure
    const loadingSpinner = document.createElement('div');
    loadingSpinner.classList.add('loading__spinner', 'hidden');
    loadingSpinner.innerHTML = `
      <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
        <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
      </svg>
    `;
    this.button.appendChild(loadingSpinner);
  }

  onAddToCartClick(event) {
    event.preventDefault();
    
    if (this.button.getAttribute('aria-disabled') === 'true') return;
    
    this.button.setAttribute('aria-disabled', 'true');
    this.button.classList.add('loading');
    this.querySelector('.loading__spinner').classList.remove('hidden');
    
    // Create the same formData structure Dawn's product-form uses
    const formData = new FormData();
    formData.append('id', this.variantId);
    formData.append('quantity', 1);
    
    if (this.cart) {
      formData.append(
        'sections',
        this.cart.getSectionsToRender().map((section) => section.section || section.id).join(',')
      );
      formData.append('sections_url', window.location.pathname);
      
      // Set active element for accessibility
      if (typeof this.cart.setActiveElement === 'function') {
        this.cart.setActiveElement(document.activeElement);
      }
    }
    
    // Use the same fetch config Dawn uses
    const config = {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    };
    
    fetch(window.Shopify.routes.root + 'cart/add.js', config)
      .then(response => response.json())
      .then(response => {
        if (response.status) {
          // Handle error case
          this.handleError(response.description);
          return;
        }
        
        if (!this.cart) {
          // Redirect to cart page if no drawer
          window.location = window.routes.cart_url;
          return;
        }
        
        // Success! Render cart contents
        this.cart.renderContents(response);
      })
      .catch(error => {
        console.error('Error adding bundle to cart:', error);
        this.handleError('An error occurred while adding this item to cart');
      })
      .finally(() => {
        this.button.classList.remove('loading');
        if (this.cart && this.cart.classList.contains('is-empty')) {
          this.cart.classList.remove('is-empty');
        }
        this.button.removeAttribute('aria-disabled');
        this.querySelector('.loading__spinner').classList.add('hidden');
      });
  }
  
  handleError(errorMessage) {
    const errorContainer = document.createElement('div');
    errorContainer.classList.add('bundle-quick-add-error');
    errorContainer.textContent = errorMessage || 'Error adding bundle to cart';
    
    this.appendChild(errorContainer);
    
    // Remove error after delay
    setTimeout(() => {
      errorContainer.remove();
    }, 5000);
  }
}

window.customElements.define('bundle-quick-add', BundleQuickAdd);